import {useEffect, useState} from 'react'
import {VoidFunction} from '../utils/types'
import {darkTheme, lightTheme} from './Themes'
import {DefaultTheme} from 'styled-components'

type Theme = 'light' | 'dark'

type Tuple = [DefaultTheme, VoidFunction, boolean]

export const useDarkMode: () => Tuple = () => {

  const [theme, setTheme] = useState<Theme>('light')
  // mountedComponent doesn't seem used
  const [mountedComponent, setMountedComponent] = useState(false)
  const setMode = (mode: Theme) => {
    window.localStorage.setItem('theme', mode)
    setTheme(mode)
  }

  const themeToggler = () => {
    theme === 'light' ? setMode('dark') : setMode('light')
  }

  useEffect(() => {
    const localTheme = window.localStorage.getItem('theme') as Theme
    localTheme ? setTheme(localTheme) : setMode('light')
    setMountedComponent(true)
  }, [])

  const themeObject = theme === "light" ? lightTheme : darkTheme;

  return [themeObject, themeToggler, mountedComponent] as Tuple
}